namespace Ir.Components.General.TextBox {

    interface IViewModel {
        textBoxConfig: DevExpress.ui.dxTextBox.Properties;
        dispose: Function;
    }
    export interface ITextBoxParams {
        text: KnockoutObservable<string>;
        width?: string | number;
        controlReadOnly?: boolean;
        readOnly?: KnockoutObservable<boolean>;
        save?: () => void;
        cancel?: () => void;
        validate?: (text: string) => boolean;
        validateMessage?: string;
        getComponent?: (component: ITextBoxComponent) => void;

        onKeyUp?: (keyCode: number) => void;
        onFocusIn?: (e: DevExpress.events.NativeEventInfo<DevExpress.ui.dxTextBox, FocusEvent>) => void;
        onFocusOut?: (e: DevExpress.events.NativeEventInfo<DevExpress.ui.dxTextBox, FocusEvent>) => void;
        onInitialized?: (e) => void;
        onValueChanged?: (e: { value: string, previousValue: string }) => void;
    }
    export interface ITextBoxComponent {
        reset: (text: string) => void;
    }

    export function getViewModel(this: IViewModel, params: ITextBoxParams, componentInfo) {
        //To allow passing all params as an object 
        if ((params as any).config) {
            params = (params as any).config;
        }
        let self = this;

        let text = params.text;
        let readOnly = params.controlReadOnly ? params.readOnly : false as any;
        //let validate = params.validate ? params.validate : function () { return true; };

        let textBoxControl: DevExpress.ui.dxTextBox;

        if (params.controlReadOnly) {
            (readOnly as KnockoutObservable<boolean>).subscribe(function (newValue) {
                if (!newValue) {
                    textBoxControl.focus();
                }
            });
        }

        if (params.getComponent) {
            params.getComponent({
                reset(text) {
                    textBoxControl.reset(text);
                }
            } as ITextBoxComponent)
        }

        $(componentInfo.element).width(params.width);

        let previousValue = text();
        this.textBoxConfig = {
            value: text as any,
            width: params.width ?? "150px",
            readOnly: readOnly as any,
            onInitialized(e) {
                textBoxControl = e.component;

                if (params.validate) {
                    e.element.dxValidator({
                        validationRules: [{
                            type: 'custom',
                            validationCallback: ({ value }) => {
                                return params.validate(value);
                            },
                            message: params.validateMessage,
                        }]
                    });
                }
            },
            onKeyUp(e) {   
                if (e.event.keyCode === 27) {//ESC
                    e.component.reset(previousValue);
                    if (params.controlReadOnly) {
                        readOnly(true);
                    }

                    if (params.cancel) {
                        params.cancel();
                    }
                }
                else if (e.event.keyCode === 13) {//ENTER
                    if (params.controlReadOnly) {
                        readOnly(true);
                    }
                }

                if (params.onKeyUp) {
                    params.onKeyUp(e.event.keyCode);
                }
            },
            onValueChanged(e) {
                previousValue = e.previousValue;
                if (!e.value && e.previousValue) {
                    text(e.previousValue);
                }

                if (e.value !== e.previousValue) {
                    if (!e.component.option("validationErrors")) {
                        if (params.save) {
                            params.save();
                        }
                    }
                }

                params.onValueChanged?.({ value: e.value, previousValue: e.previousValue });
            },
            onFocusIn(e) {
                params.onFocusIn?.(e);
            },
            onFocusOut(e) {
                if (params.controlReadOnly) {
                    readOnly(true);
                }
                params.onFocusOut?.(e);
            }
        };

        if (params.onInitialized) {
            let sub = (ko as any).bindingEvent.subscribe(componentInfo.element, 'descendantsComplete', function (node) {
                params.onInitialized({
                    element: componentInfo.element,
                })
            });

            self.dispose = function () {
                sub?.dispose();
            }
        }
    }
}